import { List, ListSubheader, ListItem, ListItemText } from '@mui/material';
import { SnapshotThreshold } from '../../types/models/SnapshotThreshold';

interface Props {
  thresholds: SnapshotThreshold[] | undefined;
  selectedThresholdId: number;
  handleThresholdClicked: (thresholdId: number) => void;
}

const ThresholdList = ({
  thresholds,
  selectedThresholdId,
  handleThresholdClicked,
}: Props) => {
  return (
    <List>
      <ListSubheader>Thresholds</ListSubheader>
      {thresholds?.map((threshold) => (
        <ListItem
          button
          key={threshold.id}
          selected={selectedThresholdId === threshold.id}
          onClick={() => handleThresholdClicked(threshold.id)}
        >
          <ListItemText key={threshold.id}>{threshold.name}</ListItemText>
        </ListItem>
      ))}
    </List>
  );
};

export default ThresholdList;
